import React from "react";
const PinterestIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "19", height: "19", viewBox: "0 0 19 19", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    d: "M9.5 2C5.358 2 2 5.344 2 9.47c0 3.165 1.975 5.87 4.765 6.958-.067-.59-.123-1.5.025-2.145.136-.584.877-3.713.877-3.713s-.223-.45-.223-1.107c0-1.039.605-1.813 1.358-1.813.642 0 .951.48.951 1.05 0 .64-.407 1.6-.623 2.49-.18.744.376 1.353 1.11 1.353 1.334 0 2.359-1.402 2.359-3.418 0-1.789-1.29-3.037-3.136-3.037-2.136 0-3.389 1.592-3.389 3.24 0 .64.247 1.328.556 1.703.061.074.068.141.049.215-.056.234-.185.744-.21.848-.03.136-.111.166-.253.099-.938-.437-1.525-1.795-1.525-2.896 0-2.354 1.716-4.518 4.957-4.518 2.599 0 4.624 1.844 4.624 4.315 0 2.576-1.63 4.648-3.89 4.648-.759 0-1.475-.394-1.715-.86l-.47 1.776c-.166.651-.623 1.463-.932 1.96.704.216 1.445.333 2.223.333 4.142 0 7.5-3.344 7.5-7.47C17 5.345 13.642 2 9.5 2z"
  }
));
var PinterestIcon_default = PinterestIcon;
export {
  PinterestIcon_default as default
};
//# sourceMappingURL=PinterestIcon.js.map
